import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Field, change} from 'redux-form';
import {connect} from 'react-redux';
import {compose} from 'recompose';
import {SelectInput} from 'admin-on-rest';
import DiscountItemTableRow from '../components/DiscountItemTableRow';
import ProductCategoryByTypeDependentSelectInput from './ProductCategoryByTypeDependentSelectInput';
import ProductUnitByTypeDependentSelectInput from './ProductUnitByTypeDependentSelectInput';
import ReactTooltip from 'react-tooltip';
import TooltipIcon from './TooltipIcon';
import {viewStyles} from '../shared/styles-view';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import IconAdd from 'material-ui/svg-icons/content/add';
import {Card, CardText} from 'material-ui/Card';
import {
    Table,
    TableHeader,
    TableHeaderColumn,
    TableRow,
    TableRowColumn,
    TableBody
} from 'material-ui';

// Default "Buy" Options for Add select
const addBuyAvailableOptions = [
    {id: 'type', name: 'Any Products of this Type'},
    {id: 'categories', name: 'Any Categories of this Type'},
    {id: 'category', name: 'Add a Product Category'},
    {id: 'item', name: 'Add a Product'}
];

// Default "Get" Options for Add select
const addGetAvailableOptions = [
    {id: 'type', name: 'Any Products of this Type'},
    {id: 'categories', name: 'Any Categories of this Type'},
    {id: 'category', name: 'Add a Product Category'},
    {id: 'item', name: 'Add a Product'}
];

/**
 * A component for adding and removing Discount Item rows
 *
 */
class DiscountItemTable extends Component {
    constructor(props) {
        super(props);

        // Populate available Add Item options
        const addOptions = this.assembleAddOptions('all', props.restrictOptions);

        this.state = {
            addChoiceType: 'all',
            addOptions: addOptions,
            addGetChoiceType: 'all',
            addedItemList: [],
            allowAdd: true,
            andOr: null,
            showAdd: false,
            isOverridden: false,
        };
    }

    componentWillReceiveProps(nextProps, nextContext) {
        const restrictOptions = nextProps.restrictOptions;
        if (this.props.restrictOptions !== restrictOptions) {
            let addOptions;

            // If another table has made an "All Products" selection, disallow "All Categories" for this table
            if (restrictOptions === 'type') {
                addOptions = this.assembleAddOptions('type', restrictOptions);
                this.setState({
                    addOptions: addOptions
                });
            }

            // If another table has made an "All Categories" selection, disallow "All Products" for this table
            if (restrictOptions === 'categories') {
                addOptions = this.assembleAddOptions('categories', restrictOptions);
                this.setState({
                    addOptions: addOptions
                });
            }
        }

        if (nextProps.addedItemValues && this.state.addedItemList.length === 0 && !this.state.isOverridden) {
            this.setState({
                addedItemList: nextProps.addedItemValues,
                isOverridden: true
            }, () => {
                this.props.onTableUpdate(this.state.addedItemList, this.props.andOr, this.props.tableType);
            })
        }
    }

    /**
     * Set options for Add select based on existing added selections
     *
     * @param addOptionType
     * @param restrictOptions
     * @return {any}
     */
    assembleAddOptions = (addOptionType, restrictOptions) => {
        const tableType = this.props.tableType;
        let optionType;
        if (addOptionType) {
            optionType = addOptionType;
        } else {
            optionType = (tableType === 'buy') ? this.state.addChoiceType : this.state.addGetChoiceType;
        }
        let options = (tableType === 'buy')
            ? JSON.parse(JSON.stringify(addBuyAvailableOptions))
            : JSON.parse(JSON.stringify(addGetAvailableOptions));

        // Disallow "All" options if a specific Category or Product was added to this list
        if (optionType === 'specific' || optionType === 'item' || optionType === 'category') {
            options = this.removeItemFromList(options, 'type', 'id');
            options = this.removeItemFromList(options, 'categories', 'id');
        }
        // Disable "Category" option if a Product was added to this list
        if (optionType === 'item') {
            options = this.removeItemFromList(options, 'category', 'id');
        }
        // Disable "Item" option if a Category was added to this list
        if (optionType === 'category') {
            options = this.removeItemFromList(options, 'item', 'id');
        }
        // Disable "All Categories" if other table has "All Products"
        if (restrictOptions === 'type') {
            options = this.removeItemFromList(options, 'categories', 'id');
        }
        // Disable "All Products" if other table has "All Categories"
        if (restrictOptions === 'categories') {
            options = this.removeItemFromList(options, 'type', 'id');
        }

        return options;
    };

    /**
     * Display or Hide Add functionality
     *
     * @param e
     * @param doDisplay
     */
    handleDisplayAddItem = (e, doDisplay) => {
        this.setState({showAdd: doDisplay});
    };

    /**
     * Update Discount form values based on selection of Add Item type
     *
     * @param e
     * @param index
     */
    handleUpdateAddItemType = (e, index) => {
        const tableType = this.props.tableType;

        if (index && index === 'category') {
            this.props.dispatch(change('record-form', tableType + '_add_item_product', null));
        }
        if (index && index === 'item') {
            this.props.dispatch(change('record-form', tableType + '_add_item_category', null));
        }
        if (index && (index === 'type' || index === 'categories')) {
            this.props.dispatch(change('record-form', tableType + '_add_item_category', null));
            this.props.dispatch(change('record-form', tableType + '_add_item_product', null));
        }
    };

    /**
     * Set AND or OR value for this table
     *
     * @param e
     * @param andOr
     */
    handleSetAddConnector = (e, andOr) => {

        // Check if items may be added after selecting AND/OR
        let addedItemList = JSON.parse(JSON.stringify(this.state.addedItemList));
        const allowAdd = this.checkAllowAdd(true, addedItemList, andOr);

        this.setState({
            andOr: andOr,
            allowAdd: allowAdd
        }, () => {
            this.props.onTableUpdate(this.state.addedItemList, this.state.andOr, this.props.tableType);
        });
    };

    /**
     * Process event for adding an assembled item as a row
     *
     * @param e
     */
    handleAddItem = (e) => {
        const tableType = this.props.tableType;
        let addedItemList = JSON.parse(JSON.stringify(this.state.addedItemList));
        const type = this.props.itemToAdd.type;

        const itemToAdd = {
            type: type
        };
        // Name the added item
        if (this.props.itemToAdd.category) {
            itemToAdd.name = this.props.itemToAdd.category;
        } else if (this.props.itemToAdd.item) {
            itemToAdd.name = this.props.itemToAdd.item;
        } else if (type === 'type') {
            itemToAdd.name = 'All Products';
        } else if (type === 'categories') {
            itemToAdd.name = 'All Categories';
        }
        itemToAdd.id = tableType + '-' + type + '-' + itemToAdd.name + '-' + addedItemList.length.toString();
        addedItemList.push(itemToAdd);

        // Update available Add options (some selections disallow others)
        let allowAdd = true;
        let addOptions;
        const restrictOptions = this.props.restrictOptions;
        if (itemToAdd.type === 'type' || itemToAdd.type === 'categories') {
            // Disable the ability to add more selections
            allowAdd = false;
            addOptions = this.assembleAddOptions('all', restrictOptions);
        } else if (itemToAdd.type === 'category') {
            addOptions = this.assembleAddOptions('category', restrictOptions);
        } else if (itemToAdd.type === 'item') {
            addOptions = this.assembleAddOptions('item', restrictOptions);
        } else {
            addOptions = this.assembleAddOptions('all', restrictOptions);
        }

        // If total added items are equal to Qty and connector is set to AND, disallow further addition
        allowAdd = this.checkAllowAdd(allowAdd, addedItemList, this.state.andOr);

        // Store this new item in the added list
        this.setState({
            addedItemList: addedItemList,
            addOptions: addOptions,
            allowAdd: allowAdd,
            andOr: this.props.andOr,
            showAdd: false
        }, () => {
            // Update the Discount form
            this.props.dispatch(change('record-form', tableType + '_add_item_category', null));
            this.props.dispatch(change('record-form', tableType + '_add_item_product', null));
            this.props.dispatch(change('record-form', tableType + '_add_item_type', null));

            // Lift state to container to assemble Discount fields and notify other table
            this.props.onTableUpdate(this.state.addedItemList, this.state.andOr, tableType);
        });
    };

    /**
     * Process event for removing a row
     *
     * @param item
     */
    handleRemoveItem = (item) => {
        let addedItemList = JSON.parse(JSON.stringify(this.state.addedItemList));
        let updatedList = this.removeItemFromList(addedItemList, item, 'name');
        const restrictOptions = this.props.restrictOptions;

        // Populate available Add options
        let addOptions;
        if (updatedList.length === 0) {
            // If the list contains no added items, allow any selection type
            addOptions = this.assembleAddOptions('all', restrictOptions);
        } else {
            // If items exist in list, only allow the current selection type
            const type = updatedList[0].type;
            addOptions = this.assembleAddOptions(type, restrictOptions);
        }

        // Remove the item from the added list
        this.setState({
            addedItemList: updatedList,
            addOptions: addOptions,
            allowAdd: true,
            andOr: this.props.andOr
        }, () => {
            // Lift state to container to assemble Discount fields and notify other table
            this.props.onTableUpdate(this.state.addedItemList, this.props.andOr, this.props.tableType);
        });
    };

    // Remove an item from an array
    removeItemFromList = (array, value, attribute) => {
        return array.filter(e => e[attribute] !== value);
    };

    /**
     * Check if more items may be added to the Buy/Get list
     *
     * @param allowAdd
     * @param list
     * @param andOr
     * @return {boolean}
     */
    checkAllowAdd = (allowAdd, list, andOr) => {
        const maxQty = (this.props.tableType === 'buy') ? this.props.buyQty : this.props.getQty;

        // If total added items are equal to Qty and connector is set to AND, disallow further addition
        if (andOr && andOr === 'AND') {
            if (list.length >= maxQty) {
                allowAdd = false;
            }
        }
        return allowAdd;
    };

    /**
     * Generate a table of added items
     *
     * @param list
     * @param removeClickFunc
     * @return {*}
     */
    makeDiscountItemsTable = (list, removeClickFunc) => {
        if (!list || list.length === 0) {
            return (
                <TableRow>
                    <TableRowColumn colSpan={3}>No Items</TableRowColumn>
                    <TableRowColumn>&nbsp;</TableRowColumn>
                </TableRow>
            )
        }
        return (
            list.map((item, index) => (
                <DiscountItemTableRow
                    key={item.id.toString()}
                    id={item.id.toString()}
                    name={item.name.toString()}
                    type={item.type}
                    onRemoveClick={removeClickFunc}
                />
            ))
        )
    };

    render() {
        const {
            buyQty,
            getQty,
            itemToAdd,
            summary,
            tableType,
            tableTypeLabel,
            tooltip,
            type
        } = this.props;

        const {
            addedItemList,
            addOptions,
            allowAdd,
            andOr,
            showAdd
        } = this.state;

        // Display title and messaging based on the Buy/Get Qty provided
        const maxQty = (tableType === 'buy') ? buyQty : getQty;
        let title;
        if (maxQty > 1 && andOr === 'AND') {
            title = 'Add up to ' + maxQty + ' ' + tableTypeLabel + ' Items from Product Type ' + type;
        } else if (maxQty > 1 && andOr === 'OR') {
            title = 'Add ' + tableTypeLabel + ' Items from Product Type ' + type;
        } else if (maxQty === 1 && andOr === 'AND') {
            title = 'Add one ' + tableTypeLabel + ' Item from Product Type ' + type;
        } else if (maxQty < 1) {
            title = 'Add ' + tableTypeLabel + ' Items once Qty is selected';
        } else {
            title = 'Add ' + tableTypeLabel + ' Items from Product Type ' + type;
        }

        const addStyle = (allowAdd && showAdd) ? {} : viewStyles.hidden;

        return (
            <div>
                {type &&
                    <Card>
                        <CardText>
                        <span style={{...viewStyles.fieldHeader, ...viewStyles.noMargin}}>
                            {title}
                            <TooltipIcon dataFor={`ttAdd${tableType}`}/>
                            <ReactTooltip id={`ttAdd${tableType}`} type="light" effect="solid" multiline={true}
                                          border={true}
                                          className="tooltip">
                                {tooltip}
                            </ReactTooltip>
                        </span>
                            <hr style={{...viewStyles.break, ...viewStyles.paddingBottom}}/>

                            <p style={viewStyles.fieldParagraph}>{summary}</p>

                            <p style={{...viewStyles.fieldParagraph, ...viewStyles.noMargin}}>
                                If you are adding multiple {tableTypeLabel} items, select whether the items should be
                                connected by AND or by OR. If only a single selection is added, the AND/OR value will
                                not
                                be needed.
                            </p>

                            {/* Select Type of Item to Add */}

                            <Field name={`${tableType}_andor`}
                                   component={SelectInput}
                                   choices={[
                                       {id: 'OR', name: 'OR'}
                                   ]}
                                   label="Select OR"
                                   onChange={this.handleSetAddConnector}
                            />

                            {/* Item Rows */}

                            <span style={viewStyles.fieldHeader}>{tableTypeLabel} Items</span>
                            <Table selectable={false} multiSelectable={false}>
                                <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                                    <TableRow>
                                        <TableHeaderColumn><span>Item</span></TableHeaderColumn>
                                        <TableHeaderColumn colSpan={2}><span>Name</span></TableHeaderColumn>
                                        <TableHeaderColumn><span>Remove</span></TableHeaderColumn>
                                    </TableRow>
                                </TableHeader>
                                <TableBody displayRowCheckbox={false}>
                                    {[...this.makeDiscountItemsTable(addedItemList, this.handleRemoveItem)]}
                                </TableBody>
                            </Table>
                            <hr style={{...viewStyles.break, ...viewStyles.paddingBottom}}/>

                            {/* Add Item Row Assembly */}

                            <div style={addStyle}>

                                {/* Select Type of Item to Add */}
                                <Field name={`${tableType}_add_item_type`}
                                       component={SelectInput}
                                       choices={addOptions}
                                       label="Select an Item to add"
                                       onChange={this.handleUpdateAddItemType}
                                />

                                {/* Add a Category */}
                                {itemToAdd.type === 'category' &&
                                    <ProductCategoryByTypeDependentSelectInput
                                        source={`${tableType}_add_item_category`}
                                        sourceName={`${tableType}_add_item_category`}
                                        dependsOn="type"
                                        dependentProp="dependsOnValue"
                                        formReference="record-form"
                                        forceReset={true}
                                        optionValue="id"
                                        optionText="name"
                                        label="Select a Product Category"
                                        className="full-width"
                                    />
                                }

                                {/* Add a Product and/or Product Unit */}
                                {itemToAdd.type === 'item' &&
                                    <ProductUnitByTypeDependentSelectInput
                                        source={`${tableType}_add_item_product`}
                                        sourceName={`${tableType}_add_item_product`}
                                        dependsOn="type"
                                        dependentProp="dependsOnValue"
                                        formReference="record-form"
                                        forceReset={true}
                                        optionValue="id"
                                        optionText="name"
                                        label="Select a Product"
                                        className="full-width"
                                    />
                                }

                                {/* Add the assembled Item */}
                                <div>
                                    <RaisedButton
                                        primary
                                        label="Add"
                                        icon={<IconAdd/>}
                                        disabled={!itemToAdd.type ||
                                            (itemToAdd.type === 'category' && !itemToAdd.category) ||
                                            (itemToAdd.type === 'item' && !itemToAdd.item)}
                                        onClick={(e) => this.handleAddItem(e)}
                                        style={viewStyles.rowShowField}
                                    />
                                    <FlatButton
                                        primary
                                        label="Cancel"
                                        onClick={(e) => this.handleDisplayAddItem(e, false)}
                                        style={viewStyles.rowShowField}
                                    />
                                </div>
                            </div>

                            {/* Add Item Display */}

                            {allowAdd && !showAdd && maxQty > 0 &&
                                <div>
                                    <RaisedButton
                                        primary
                                        label={`Add ${tableTypeLabel} Item`}
                                        icon={<IconAdd/>}
                                        onClick={(e) => this.handleDisplayAddItem(e, true)}
                                        style={viewStyles.rowShowField}
                                    />
                                </div>
                            }

                        </CardText>
                    </Card>
                }
                <hr style={{...viewStyles.break, ...viewStyles.paddingBottom}}/>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    let form = state.form['record-form'];
    let tableType = ownProps.tableType;
    if (form && form.values) {
        const addAndOr = (form.values[tableType + '_andor']) ? form.values[tableType + '_andor'] : 'AND';
        const addItemCategory = (form.values[tableType + '_add_item_category']) ? form.values[tableType + '_add_item_category'] : null;
        const addItemProduct = (form.values[tableType + '_add_item_product']) ? form.values[tableType + '_add_item_product'] : null;
        const addItemType = (form.values[tableType + '_add_item_type']) ? form.values[tableType + '_add_item_type'] : null;

        const addedItemValues = (form.values[ownProps.tableType + '_values']) ? form.values[ownProps.tableType + '_values'] : null;

        // Assemble an Item to Add if available
        const itemToAdd = {
            category: addItemCategory,
            item: addItemProduct,
            type: addItemType
        };

        return {
            andOr: addAndOr,
            itemToAdd: itemToAdd,
            addedItemValues: addedItemValues
        }
    }
    return {}
};

DiscountItemTable.propTypes = {
    addedItemValues: PropTypes.array,
    addField: PropTypes.bool,
    andOr: PropTypes.string,
    itemToAdd: PropTypes.object,
    buyQty: PropTypes.number,
    getQty: PropTypes.number,
    onTableUpdate: PropTypes.func,
    restrictOptions: PropTypes.string,
    tableType: PropTypes.string,
    tableTypeLabel: PropTypes.string,
    summary: PropTypes.string,
    tooltip: PropTypes.string,
    type: PropTypes.string,
};

DiscountItemTable.defaultProps = {
    addedItemValues: [],
    addField: true,
    andOr: null,
    itemToAdd: {
        category: null,
        item: null,
        type: null
    },
    buyQty: 0,
    getQty: 0,
    restrictOptions: null,
    summary: 'Add one or more Product Types, Categories, and/or Products for this BXGY Discount.',
    tableType: 'buy',
    tableTypeLabel: 'Buy',
    tooltip: 'Assemble rows of items for this BXGY Discount.',
};

const enhance = compose(
    connect(mapStateToProps)
);

export default enhance(DiscountItemTable);



// WEBPACK FOOTER //
// ./src/Fuse/components/DiscountItemTable.js